import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", ".open"]
const _hoisted_2 = {
  id: "modal-container-element",
  class: "modal-content"
}
const _hoisted_3 = {
  key: 0,
  class: "progress-info text info mb-10 mt-20"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { useStore } from 'vuex'
import { ref } from 'vue';
import Banner from '@components/Banner/Banner.vue';
import Tabs from '../components/application/Tabs.vue';
import { App } from '../models/application/ui-types';
import { createManifest, exportChartAndImages } from '../models/application/actions/export';
import { AppExportCancelMap } from '../models/application/ui-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportAppModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const t = store.getters['i18n/t'];

const showModal = ref(false);
const activeTab = ref<string | number>('manifest')
const tabs = ref([
  { id: 'manifest', label: 'Manifest', completed: false, valid: false, disabled: false, visible: true },
  { id: 'chartAndImages', label: 'Chart and Images', completed: false, valid: false, disabled: false, visible: true },
]);
const showProgressBar = ref<boolean>(false);
const step = ref<string | null>(null);
const cancelMap = ref<AppExportCancelMap>({});
const appToExport = ref<App | null>(null);
const resources = ref<Array<App>>([]);
const exporting = ref<boolean>(false);
const errors = ref<Array<string>>([]);

function openExport(app: App) {
  appToExport.value = app;
  resources.value = [app];
  showModal.value = true;
}

const exportApplicationManifest = async () => {
  exporting.value = true;
  enableDownload();
  const resource = resources.value[0];
  let exportSucceeded = false;

  try {
    if (activeTab.value === 'manifest') {
      await createManifest(store, resource);
    } else {
      await exportChartAndImages(store, resource, (part, isPreparing = false) => {
        toggleStep(part, isPreparing);
      }, cancelMap.value);
      await delayBeforeClose(1500);
    }

    store.dispatch('growl/success', {
      title:   t('epinio.growl.application.export.success.title'),
      message: t('epinio.growl.application.export.success.message', { name: resource.meta.name }),
    });
    exportSucceeded = true;
  } catch (e: any) {
    if (e.name === 'AbortError') {
      disableDownload();
    } else {
      errors.value.push(e.message ?? 'Error exporting application');
      disableDownload();
      store.dispatch('growl/error', {
        title:   t('epinio.growl.application.export.error.title'),
        message: t('epinio.growl.application.export.error.message'),
      });
    }
  } finally {
    exporting.value = false;
    if (exportSucceeded) closeExport();
  }
};

const fetchCancel = () => {
  Object.entries(cancelMap.value).forEach(([part, controller]) => {
    console.log(part, {
      before: controller.signal.aborted,
    });

    controller.abort();

    console.log(part, {
      after: controller.signal.aborted,
      reason: controller.signal.reason,
    });
  });

  cancelMap.value = {};
};

const closeExport = () => {
  fetchCancel();
  resources.value = [];
  showProgressBar.value = false;
  step.value = null;
  exporting.value = false;
  showModal.value = false;
}

const resetErrors = () => {
  errors.value = [];
}

const enableDownload = () => {
  resetErrors();
  showProgressBar.value = true;
}

const disableDownload = () => {
  fetchCancel();
  showProgressBar.value = false;
  toggleStep(null);
}

const delayBeforeClose = async (seconds: number) => {
  return await new Promise((resolve) => setTimeout(resolve, seconds));
}

const toggleStep = (part: string | null, isPreparing = false) => {
  step.value = part ? `${ isPreparing ? 'preparing' : 'download' }.${ part }` : null;
}

__expose({
  openExport,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    title: _unref(t)('epinio.applications.export.label'),
    ".open": showModal.value,
    dismissible: false,
    onModalClose: closeExport
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        tabs: tabs.value,
        variant: "underline"
      }, {
        manifest: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('epinio.applications.export.manifest.description')), 1)
        ]),
        chartAndImages: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('epinio.applications.export.chartValuesImages.description')), 1),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createVNode(Banner, { color: "info" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('epinio.applications.export.chartValuesImages.banner')), 1)
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode()),
          (showProgressBar.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon-spinner animate-spin mr-5" }, null, -1)),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (step.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)(`epinio.applications.export.chartValuesImages.steps.${ step.value }`)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1,
        __: [5]
      }, 8, ["modelValue", "tabs"]),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (err, i) => {
        return (_openBlock(), _createBlock(Banner, {
          key: i,
          color: "error",
          label: err
        }, null, 8, ["label"]))
      }), 128))
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeExport
      }, "\n        Cancel\n      ", 32),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        variant: "destructive",
        disabled: exporting.value,
        onButtonClick: exportApplicationManifest
      }, _toDisplayString(exporting.value ? 'Exporting...' : 'Export'), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})